import { Link } from 'react-router-dom';

import classes from './NavbarLogo.module.css';




const NavbarLogoDashboard = ({ onClick }) => {
    return (
      <Link to="/" onClick={onClick}>
        <img
          src="/img/autosmart-logo-white.svg"
          alt="Logo"
          loading="lazy"
          className={classes.navbarLogo}
        />
      </Link>
    );
  };
  
  export default NavbarLogoDashboard;